<template>
  <div class="teaching-score-table"
       v-loading="loading"
       element-loading-text="数据加载中，请稍等...">
    <div class="score-table-header">
      <el-form size="mini" label-width="86px">
        <el-form-item label="选择教学点">
          <el-select v-model="siteId"
                     size="mini"
                     filterable
                     placeholder="请选择教学点"
                     @change="handleSiteChange">
            <el-option v-for="site in sites"
                       :key="site.id"
                       :label="site.name"
                       :value="site.id"/>
          </el-select>
        </el-form-item>
        <el-form-item label="选择班级">
          <el-select v-model="classId"
                     size="mini"
                     filterable
                     placeholder="请选择班级"
                     :disabled="!siteId || !classList.length"
                     @change="handleClassChange">
            <el-option v-for="clazz in classList"
                       :key="clazz.id"
                       :label="clazz.name"
                       :value="clazz.id"/>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <div class="score-table-content">
      <keep-alive>
        <TemplateDataGrid v-if="showGrid"
                          ref="grid"
                          :key="gridKey"
                          gridId="PeTchScoreTable"
                          v-bind="gridParams"></TemplateDataGrid>
      </keep-alive>
    </div>
  </div>
</template>

<script>
import TemplateDataGrid from '../../../../../../templates/TemplateDataGrid'

export default {
  name: 'TeachingScoreTable',
  components: {
    TemplateDataGrid
  },
  data () {
    return {
      loading: false,
      // 站点相关
      sites: [],
      siteId: '',
      // 班级相关
      classList: [],
      classId: '',
      // 控制表格显示
      showGrid: false,
      // 用于强制刷新grid
      gridKey: 0
    }
  },
  computed: {
    gridParams () {
      return {
        classId: this.classId
      }
    }
  },
  methods: {
    // 加载站点数据
    loadSites () {
      this.loading = true
      this.$ajax({
        url: '/workspace/manager/portal/data/select/sites',
        method: 'post'
      }).then(response => {
        if (response.data) {
          this.sites = response.data['sites'] || []
          if (this.sites.length) {
            this.siteId = this.sites[0].id
            this.loadClassList()
          }
        }
      }).catch(() => {
        this.$message.error('请求发送失败，请稍后重试')
      }).finally(() => {
        this.loading = false
      })
    },
    // 加载班级列表
    loadClassList () {
      if (!this.siteId) {
        this.classList = []
        return
      }
      this.loading = true
      this.$ajax({
        url: '/workspace/manager/portal/data/select/clazzList',
        method: 'post',
        data: this.$qs.stringify({
          siteId: this.siteId
        })
      }).then(response => {
        if (response.data) {
          this.classList = response.data['clazzList'] || []
          if (this.classList.length) {
            this.classId = this.classList[0].id
            this.handleQuery()
          } else {
            this.classId = ''
            this.showGrid = false
          }
        }
      }).catch(() => {
        this.$message.error('请求发送失败，请稍后重试')
      }).finally(() => {
        this.loading = false
      })
    },
    // 站点变更后加载班级
    handleSiteChange () {
      this.classId = ''
      this.showGrid = false
      this.loadClassList()
    },
    // 班级变更后触发查询
    handleClassChange () {
      this.handleQuery()
    },
    // 提交查询
    handleQuery () {
      if (!this.classId) {
        this.showGrid = false
        return
      }
      // 刷新gridKey强制重新渲染TemplateDataGrid组件
      this.gridKey = Date.now()
      this.showGrid = true
    },
    // 初始化数据
    initData () {
      this.loadSites()
    }
  },
  mounted () {
    this.initData()
  }
}
</script>

<style lang="scss">
  .teaching-score-table {
    height: 100%;
    display: flex;
    flex-direction: column;
    .score-table-header {
      padding: 15px;
      background-color: #fff;
      .el-form {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        .el-form-item {
          margin-bottom: 0;
          margin-right: 20px;
          .el-select {
            width: 180px;
          }
        }
      }
    }
    .score-table-content {
      flex: 1;
      overflow: hidden;
    }
  }
</style>
